(function () {
  document.addEventListener('DOMContentLoaded', function () {
    const sticky = document.querySelector('.sticky-add-to-cart');
    if (!sticky) return;

    // Use the section-specific ID injected via Liquid into the onclick
    const stickyButton = sticky.querySelector('.sticky-add-to-cart__button');
    if (!stickyButton) return;

    // Derive section ID from the sticky container's own ID
    const sectionId = sticky.id.replace('sticky-add-to-cart-', '');
    const mainButton = document.getElementById('ProductSubmitButton-' + sectionId);
    if (!mainButton) return;

    const observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            sticky.classList.remove('is-visible');
          } else {
            sticky.classList.add('is-visible');
          }
        });
      },
      { threshold: 0 }
    );

    observer.observe(mainButton);
  });
})();
